// extracted by mini-css-extract-plugin
export default {"link":"rD-z","disabled":"sD-z"};